import appAxios from 'axios'

const axios = appAxios.create({
  headers: {
    Authorization: 'Bearer FED701B733B64E2BB73F4C97BA6AA363'
  }
})

export default axios
